import { Component, Vue } from 'vue-property-decorator';
import {
  redirectToMarketAuth,
  redirectToMarketAuthWithPretnumerique,
} from '../../auth';
import IconText from './iconText.vue';

@Component({ components: { IconText } })
export default class Welcome extends Vue {
  public loginClickedLibrary(): void {
    redirectToMarketAuthWithPretnumerique();
  }

  public loginClickedBookshop(): void {
    redirectToMarketAuth();
  }
}
